"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

// fa-minus
var Minus = function Minus() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M446.3,232v51.8c0,7.2-2.5,13.3-7.6,18.4s-11.2,7.6-18.4,7.6H92.2c-7.2,0-13.3-2.5-18.4-7.6s-7.6-11.2-7.6-18.4V232c0-7.2,2.5-13.3,7.6-18.4c5-5,11.2-7.6,18.4-7.6h328.2c7.2,0,13.3,2.5,18.4,7.6C443.8,218.7,446.3,224.8,446.3,232z"
  }));
};

Minus.displayName = 'Minus';
var _default = Minus;
exports["default"] = _default;
Minus.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Minus"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Minus.js"] = {
    name: "Minus",
    docgenInfo: Minus.__docgenInfo,
    path: "src/Minus.js"
  };
}